var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.281,
    height: 144.448,
    viewBox: "0 0 111.281 144.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160947",
    "data-name": "Grupo 160947",
    transform: "translate(-823.101 -118.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11077",
    "data-name": "Grupo 11077",
    transform: "translate(785.165 -208.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311",
    transform: "translate(37.936 402.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_32",
    "data-name": "Elipse 32",
    cx: 11.051,
    cy: 11.051,
    r: 11.051,
    transform: "matrix(0.023, -1, 1, 0.023, 0, 22.095)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310",
    transform: "translate(6.115 9.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_473",
    "data-name": "Caminho 473",
    d: "M48.743,446.624a1.206,1.206,0,1,1-1.429-.931A1.206,1.206,0,0,1,48.743,446.624Z",
    transform: "translate(-46.357 -443.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_474",
    "data-name": "Caminho 474",
    d: "M54.335,445.441a1.206,1.206,0,1,1-1.429-.93A1.206,1.206,0,0,1,54.335,445.441Z",
    transform: "translate(-47.888 -443.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_475",
    "data-name": "Caminho 475",
    d: "M59.928,444.259a1.206,1.206,0,1,1-1.429-.931A1.206,1.206,0,0,1,59.928,444.259Z",
    transform: "translate(-49.42 -443.302)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_313",
    "data-name": "Grupo 313",
    transform: "translate(47.538 343.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_476",
    "data-name": "Caminho 476",
    d: "M143.437,426.916c-1.046-3.03-9.719-4.494-13.377-9.718S90.244,380.621,87.527,376.44s-8.674-10.137-12.541-7.106-.731,6.27-.731,6.27l7.106,12.018-2.508,4.18-3.033-4.159c-14.633-17.433-17.136-20.5-21.734-19.249s-2.4,4.284-2.4,4.284l19.229,36.681s-.274.108-.747.312c3.955-.63,7.644,1.675,12.138,7.84s8.779,15.78,10.033,18.393-4.285,4.18-6.061,4.284-4.807-.522-8.36-4.389-9.371-11.593-11.078-14-5.435-2.187-5.435-2.187c-.092,4.452-.1,12.622-.1,14.384a10.371,10.371,0,0,1,4.186,1.075,23.481,23.481,0,0,1,10.445,9.823c2.717,4.807,7,12.646,7,13.063s-3.345,3.553-3.345,3.553-4.284-.1-6.27-1.567-4.223-3.962-7.779-7.505a32.117,32.117,0,0,0-8.246-5.672c.438,3.365,1.939,6.583,4.216,11.5,3.239,7,13.585,24.454,13.585,24.454H135.6s10.45-30.411,11.182-34.591S144.482,429.947,143.437,426.916Z",
    transform: "translate(-51.158 -355.102)",
    fill: "#be5532"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_477",
    "data-name": "Caminho 477",
    d: "M67.134,447.092c.624-2.961,15.472-77.547,17.234-86.536a27.453,27.453,0,0,0,.588-3,8.1,8.1,0,0,1,8.221-7.246c7.664-.279,47.237,0,47.237,0s10.45-.418,8.082,11.286c-1.76,8.7-14.126,81.221-15.326,89a11.773,11.773,0,0,1-2.5,6.192c-3.767,4.186-11.588,4.2-16.73,4.158-16.153-.139-38.985,0-39.015,0a10.84,10.84,0,0,1-4.765-1.353c-3.243-1.716-4.146-4.629-3.749-8.177C66.57,449.99,66.828,448.544,67.134,447.092Z",
    transform: "translate(-55.311 -350.183)",
    fill: "#393f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_478",
    "data-name": "Caminho 478",
    d: "M71.017,446.624l16.581-85a7.418,7.418,0,0,1,8.221-7.245c8.082.278,41.106-.008,41.106-.008s6.688.426,5.434,6.975S125.081,448.3,125.081,448.3s-.619,4.137-4.181,4.282c-3.628.148-43.334,0-43.334,0S69.776,452.981,71.017,446.624Z",
    transform: "translate(-56.559 -351.331)",
    fill: "#3271cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_479",
    "data-name": "Caminho 479",
    d: "M147.657,427.705c.208-2.717,2.087-9.467,3.343-10.429-.278-.021-.567-.022-.839-.022-1.15,0-2.612-1.045-8.464,6.665a37.184,37.184,0,0,0-7.629,20.193c-.209,4.494,1.881,7.838-5.748,17.87a150.4,150.4,0,0,0-13.063,20.9s-25.917,7.211-31.038,7.628-8.485-4.841-8.49-4.852c3.2,5.626,6.087,10.495,6.087,10.495h60.508s10.45-30.411,11.182-34.591a28.1,28.1,0,0,0-.383-7.209h0l-.009-.061c-.032-.223-.065-.447-.1-.672l-.005-.036v0c-.556-3.674-1.391-7.675-2.067-10.422-.737-4.079-1.352-8.111-1.192-9.487h0c.015-.25.038-.529.068-.829a3.877,3.877,0,0,1-.488-.645A5.984,5.984,0,0,1,147.657,427.705Z",
    transform: "translate(-57.886 -368.536)",
    fill: "#cb6847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_480",
    "data-name": "Caminho 480",
    d: "M179.471,418.849h0c.32-1.2-.458-1.479-1.355-1.546-1.256.961-3.134,7.711-3.343,10.429a5.984,5.984,0,0,0,1.672,4.494,3.876,3.876,0,0,0,.488.645c.415-4.135,2.184-12.693,2.538-14.02Z",
    transform: "translate(-85.003 -368.563)",
    fill: "#9e523e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_312",
    "data-name": "Grupo 312",
    transform: "translate(5.997 54.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_481",
    "data-name": "Caminho 481",
    d: "M70.7,437.416c1.707,2.41,7.525,10.137,11.078,14s6.583,4.494,8.36,4.389,7.315-1.672,6.061-4.284S90.657,439.3,86.163,433.131s-8.183-8.469-12.138-7.84c-.937.4-2.669,1.189-4.682,2.3-3.025,1.672-3.767,3.031-3.977,4.912-.044.4-.078,1.394-.106,2.725C65.262,435.23,68.99,435.006,70.7,437.416Z",
    transform: "translate(-61.017 -425.191)",
    fill: "#cb6847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_482",
    "data-name": "Caminho 482",
    d: "M75.576,484.77c1.985,1.462,6.27,1.567,6.27,1.567s3.345-3.135,3.345-3.553-4.285-8.256-7-13.063A23.481,23.481,0,0,0,67.743,459.9a10.37,10.37,0,0,0-4.186-1.075v.343a12.447,12.447,0,0,0-3.971,7.943,16.782,16.782,0,0,0-.036,4.484,32.118,32.118,0,0,1,8.246,5.672C71.352,480.808,73.59,483.307,75.576,484.77Z",
    transform: "translate(-59.417 -434.4)",
    fill: "#cb6847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_483",
    "data-name": "Caminho 483",
    d: "M94.827,456.259l3.239,5.957s.94,1.9,4.389.951,2.532-2.69,1.777-4.3-3.344-5.643-3.344-5.643a2.627,2.627,0,0,0-3.345-.941C95.349,453.229,94.073,454.874,94.827,456.259Z",
    transform: "translate(-69.054 -432.539)",
    fill: "#9e523e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_484",
    "data-name": "Caminho 484",
    d: "M87.428,488.38l1.986,5.093c.593,1.518,3.528-.786,3.78-1.688.5-1.8-1.407-4.07-2.464-5.329-.648-.772-1.529-1.862-2.615-1.5C86.642,485.441,87,487.286,87.428,488.38Z",
    transform: "translate(-66.985 -441.536)",
    fill: "#9e523e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    transform: "translate(54.023 329.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10056",
    "data-name": "Grupo 10056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5450",
    "data-name": "Caminho 5450",
    d: "M114.5,350.861a2.2,2.2,0,0,0-.467-.7L95.191,331.322a2.18,2.18,0,0,0-1.529-.635H68.531a8.45,8.45,0,0,0-8.442,8.441v50.257a8.453,8.453,0,0,0,8.442,8.442h37.693a8.453,8.453,0,0,0,8.442-8.442V351.692A2.191,2.191,0,0,0,114.5,350.861Z",
    transform: "translate(-60.089 -330.687)",
    fill: "#b8e8e5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315",
    transform: "translate(47.538 327.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10056-2",
    "data-name": "Grupo 10056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5450-2",
    "data-name": "Caminho 5450",
    d: "M105.568,347.183a2.232,2.232,0,0,0-.467-.7L86.26,327.644a2.179,2.179,0,0,0-1.529-.635H59.6a8.45,8.45,0,0,0-8.442,8.442v50.257a8.452,8.452,0,0,0,8.442,8.441H97.292a8.453,8.453,0,0,0,8.442-8.441V348.014A2.192,2.192,0,0,0,105.568,347.183Zm-18.677-12.8,11.471,11.473H86.891Zm10.4,55.448H59.6a4.127,4.127,0,0,1-4.122-4.122V335.451a4.127,4.127,0,0,1,4.122-4.122H82.572v16.686a2.16,2.16,0,0,0,2.16,2.16h16.688v35.534A4.127,4.127,0,0,1,97.292,389.83Z",
    transform: "translate(-51.158 -327.009)",
    fill: "#54bbb1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8162",
    "data-name": "Grupo 8162",
    transform: "translate(15.466 26.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8257",
    "data-name": "Caminho 8257",
    d: "M157.486,164.085h6.344v-6.34h4.794v6.34h6.341v4.781h-6.341v6.354H163.83v-6.349h-6.344Zm4.193-8.5v6.346h-6.346v9.093h6.346v6.35h9.1v-6.348h6.346v-9.1h-6.346v-6.346Z",
    transform: "translate(-155.333 -155.588)",
    fill: "#54bbb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_318",
    "data-name": "Grupo 318",
    transform: "translate(117.77 359.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 11.704,
    cy: 11.704,
    r: 11.704,
    transform: "matrix(0.893, -0.451, 0.451, 0.893, 0, 10.555)",
    fill: "#bcd7ee"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5439",
    "data-name": "Caminho 5439",
    d: "M167.14,392.316l1.58,3.128a1.043,1.043,0,0,0,1.4.462h0a1.047,1.047,0,0,0,.461-1.4L169,391.372l3.131-1.582a1.069,1.069,0,0,0,.461-1.4,1.044,1.044,0,0,0-1.4-.464h0l-3.128,1.58-1.579-3.128a1.048,1.048,0,0,0-1.4-.461,1.068,1.068,0,0,0-.461,1.4l1.579,3.128-3.131,1.581a1.045,1.045,0,0,0,.945,1.864Z",
    transform: "translate(-151.878 -375.186)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.05105deebc31cb039de78deebd7da824.svg";
export { ForwardRef as ReactComponent };